import { AppBar, Toolbar, Box, Typography, Avatar, Button, Container, Stack } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { csrfToken } from "../api/client";
import { FREEDOM_BLUE, FREEDOM_ORANGE } from "../theme";

function NavLink({ to, children }) {
  const { pathname } = useLocation();
  const active = pathname === to;
  return (
    <Button component={RouterLink} to={to} color="inherit" size="small"
      sx={{ color: "#fff", opacity: active ? 1 : 0.7, borderRadius: 0,
            borderBottom: active ? `2px solid ${FREEDOM_ORANGE}` : "2px solid transparent" }}>
      {children}
    </Button>
  );
}

export default function Layout({ children }) {
  const { user } = useAuth();
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <AppBar position="static" elevation={0} sx={{ bgcolor: FREEDOM_BLUE, color: "#fff" }}>
        <Toolbar>
          <img src="/brand/freedom-horizontal-white.png" alt="Freedom Power" style={{ height: 26 }} />
          <Stack direction="row" spacing={1} sx={{ ml: 3 }}>
            <NavLink to="/review">Review</NavLink>
            {user?.admin && <NavLink to="/settings">Settings</NavLink>}
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          {user && (
            <>
              <Avatar src={user.avatar_url} sx={{ width: 28, height: 28, mr: 1 }} />
              <Typography variant="body2" sx={{ mr: 2, color: "#fff", display: { xs: "none", sm: "block" } }}>
                {user.email}
              </Typography>
              <form method="post" action="/logout">
                <input type="hidden" name="authenticity_token" value={csrfToken() || ""} />
                <Button type="submit" size="small" sx={{ color: "#fff" }}>Log out</Button>
              </form>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ py: 3 }}>{children}</Container>
    </Box>
  );
}
